import React from "react"

import { IconProps } from "types/icon"

const Cart: React.FC<IconProps> = ({ size = "16", color = "#444444" }) => {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.9074 27.2856C22.4341 27.2856 22.0503 26.9017 22.0503 26.4284C22.0503 25.9551 22.4341 25.5713 22.9074 25.5713C23.3809 25.5713 23.7646 25.9551 23.7646 26.4284C23.7646 26.9017 23.3809 27.2856 22.9074 27.2856Z"
        fill={color}
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7646 27.2856C11.2912 27.2856 10.9075 26.9017 10.9075 26.4284C10.9075 25.9551 11.2912 25.5713 11.7646 25.5713C12.238 25.5713 12.6218 25.9551 12.6218 26.4284C12.6218 26.9017 12.238 27.2856 11.7646 27.2856Z"
        fill={color}
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 5H9.29573L9.7479 9.28571M9.7479 9.28571L10.8521 19.7509C10.9441 20.6234 11.6816 21.2857 12.5609 21.2857H23.4188C24.2072 21.2857 24.8945 20.7503 25.0858 19.9872L27.2336 11.4158C27.5046 10.3338 26.6845 9.28571 25.5666 9.28571H9.7479Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default Cart
